
export default{
	$newFashion:true,
}